import React, { ReactElement, FunctionComponent, RefObject } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import ListTeaserHeadline from '../../Theme/Fonts/ListTeaserHeadline'
import TeaserInfo from '../../TeaserInfo'
import { TestID } from '../../utils/PropTypesDefinitions'
import { ChannelProps } from '../TeaserInterface'
import VideoRecommendationTeaserImage from './Image'

export type VideoRecommendationProps = {
    /** url of the main image */
    mainImageUrl?: string
    /** info for seo about mainImageUrl */
    mainImageAlt?: string
    /** prop for videos, shows duration of the clip */
    videoDuration?: string
    /** properties of the corresponding tag */
    tag?: ChannelProps
    /** headline to display */
    headlineText: string
    /**
     * @TJS-type function
     *
     * function that will be called when the share icon is clicked
     * if no function is provided, the share icon will be hidden
     */
    onShare?: () => void
    /**
     * @TJS-type function
     *
     * function that will be called when the teaser is clicked
     */
    onPress?: () => void
    /** text that indicates when the content was created */
    published?: string
    /**
     * property for ref forwarding
     * @TJS-type React.RefObject<Element>
     * */
    innerRef?: RefObject<Element>
} & TestID

const VideoRecommendationTeaser: FunctionComponent<VideoRecommendationProps> = ({
    mainImageUrl,
    mainImageAlt,
    videoDuration,
    headlineText,
    tag,
    published,
    onShare,
    onPress,
    innerRef,
    testID,
}): ReactElement => {
    return (
        <Grid ref={innerRef} noExpand width={203}>
            <Touchable onPress={onPress} testID={testID}>
                <VideoRecommendationTeaserImage
                    imageUrl={mainImageUrl}
                    alt={mainImageAlt}
                    videoDuration={videoDuration}
                />
                <Grid noExpand marginTop={3} marginBottom={3} height={66}>
                    <ListTeaserHeadline numberOfLines={3} color="WHITE">
                        {headlineText}
                    </ListTeaserHeadline>
                </Grid>
            </Touchable>
            <TeaserInfo
                imageUrl={tag?.imageUrl}
                alt={tag?.imageAlt}
                published={published}
                name={tag?.name}
                onShare={onShare}
                color="WHITE"
                tintColor={tag?.imageTintColor}
            />
        </Grid>
    )
}

export default VideoRecommendationTeaser
